import { startOfWeek as startOfWeekFns } from 'date-fns';

export default function startOfWeek(date: Date, sundayStart?: boolean): Date {
  const weekStartsOn = sundayStart ? 0 : 1;
  return startOfWeekFns(date, { weekStartsOn });
}
